var React = require("react");
var $ = require('jquery');
var Reflux = require('reflux');
var moment = require('moment');

// Stores
var LanguageStore = require('../stores/language_store');

// Job Area
module.exports = React.createClass({

	// Render
  	render: function(){
   		return (
   			<div className="job-publish-date">
   				<span className="fa fa-calendar icon"></span>
   				<div className="info">
   					<label>{LanguageStore.get('job_ad/title/posted_on')}</label>
   					<span className="name">{this.props.publish_date.split(' ')[0].replace(/-/ig, '/')}</span>
   				</div>
   				<div className="clear"></div>
	  		</div>
	  	);
	}
});
